import { Nullable } from '@clearverify/types';

export type OpenDataDisputeForPositionModalArgs = {
  consumerId: string;
  positionId: string;
  employeeFirstName: string;
  employeeLastName: string;
};

export enum OpenDataDisputeForPositionFormFields {
  reason = 'reason',
}

export type OpenDataDisputeForPositionFormValues = {
  [OpenDataDisputeForPositionFormFields.reason]: Nullable<string>;
};
